import AddIcon from '@mui/icons-material/Add'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'

import Button from '@/app/component/atom/button'

type Props = {
  onAddExistingQuota: () => void
  onCreateQuota: () => void
}

const QuotaAddButton: React.FC<Props> = ({ onAddExistingQuota, onCreateQuota }) => {
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<HTMLElement | null>(null)

  const handleMenuClose = () => setMenuAnchorEl(null)

  const handleMenuAction = (action: () => void) => {
    handleMenuClose()
    action()
  }

  return (
    <>
      <Button
        aria-controls={menuAnchorEl ? 'add-quota-menu' : undefined}
        aria-expanded={menuAnchorEl ? 'true' : undefined}
        aria-haspopup="menu"
        className="campaign-item-content-add-button"
        color="primary"
        endIcon={<ArrowDropDownIcon />}
        startIcon={<AddIcon />}
        variant="contained"
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
      >
        Add quota
      </Button>
      <Menu id="add-quota-menu" anchorEl={menuAnchorEl} open={!!menuAnchorEl} onClose={handleMenuClose}>
        <MenuItem divider onClick={() => handleMenuAction(onCreateQuota)}>
          <ListItemIcon>
            <AddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Create a new quota"
            secondary="Define a name, goal and conditions from scratch."
            slotProps={{ primary: { sx: { fontWeight: 600 } } }}
          />
        </MenuItem>
        <MenuItem onClick={() => handleMenuAction(onAddExistingQuota)}>
          <ListItemIcon>
            <FolderOpenIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Add one from your account"
            secondary="Reuse a quota saved to your account."
            slotProps={{ primary: { sx: { fontWeight: 600 } } }}
          />
        </MenuItem>
      </Menu>
    </>
  )
}

export default QuotaAddButton
